<template>
    <section
        class="carta__hero"
    >
        <img :src="content.banner" class="carta__banner" alt="banner">
        <div class="wrapper carta__hero-content">
            <h2>{{content.title}}</h2>
            <p>{{content.description}}</p>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        content: { required: true },
    }
}
</script>
